export const SMS_SERVICE_BASE_URI = '/api/dashboard/sms-service'

export const TEMPLATE_PATH = `${SMS_SERVICE_BASE_URI}/template`
export const TEMPLATE_LIST_PATH = `${TEMPLATE_PATH}/list`
export const TEMPLATE_COUNT_PATH = `${TEMPLATE_PATH}/count`
export const TEMPLATE_LIST_ALL_PATH = `${TEMPLATE_PATH}/my-templates`
